import type { Stage } from "@breeze/shared";

// Per-stage accent colour (hex). Matches tailwind.config stage.* scale.
// Used for column headers, card left borders, and slide-out highlights.
export const STAGE_ACCENT: Record<Stage, string> = {
  lead: "#36C5F0",
  opportunity: "#ECB22E",
  chase: "#F07B3F",
  schedule: "#7F6DC5",
  won: "#2EB67D",
  lost: "#E01E5A",
  // Aubergine-light — matches the Recruitment view's accent so the
  // Technicians column visually ties back to the recruitment workflow.
  tech: "#A678A8",
};

// Presence colours by user. Unknown users fall back to a stable hash palette.
const USER_COLORS: Record<string, string> = {
  "darren@carpetcleaning.co.uk": "#7E3A7F",
  "darren@dmarcwizard.com": "#7E3A7F",
  "andzelika@carpetcleaning.co.uk": "#2EB67D",
};
const FALLBACK_PALETTE = ["#36C5F0", "#ECB22E", "#E01E5A", "#A678A8", "#F07B3F"];
function hashCode(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}
export function userColor(email: string): string {
  const lower = email.toLowerCase();
  if (USER_COLORS[lower]) return USER_COLORS[lower];
  return FALLBACK_PALETTE[hashCode(lower) % FALLBACK_PALETTE.length] as string;
}

export const LOST_REASONS = [
  "Price",
  "Scheduling didn't work",
  "No response",
  "Chose competitor",
  "Not ready yet",
  "Other",
] as const;
export type LostReason = (typeof LOST_REASONS)[number];
